import axios from 'axios';

const baseURL = 'https://xronologio-back.theacropolismuseum.gr/';

const instance = axios.create({
  baseURL: baseURL
});

export default {baseURL, instance};
